/*
 * Project: BookingEngine
 * Module: components/common/ShareCopyLink.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';
import PropTypes from 'prop-types';
import ReactTimeout from 'react-timeout';
import { connect } from 'react-redux';
import { sendGTMEvents } from '../../actions/Booking';

class ShareCopyLink extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCopied: false,
    };
    this.handleCopy = this.handleCopy.bind(this);
  }

  handleCopy() {
    const { url, setTimeout } = this.props;
    navigator.clipboard.writeText(url)
      .then(() => {
        sendGTMEvents([{ event: 'ShareLink-Copy' }]);
        this.setState({ isCopied: true });
        setTimeout(() => this.setState({ isCopied: false }), 2000);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error('Failed to copy text: ', err);
      });
  }

  render() {
    return (
      <div className="main-content link-text">
        <p className="mb-2 text-xxs">
          {this.props.url}
        </p>
        <section className="share-item" onClick={this.handleCopy}>
          <div className="share-item__icon">
            <i className="fa fa-link" aria-hidden />
            <label className={`share-item__icon-hint ${this.state.isCopied ? 'visible' : ''}`}>
              {this.context.t('Copied!')}
            </label>
          </div>
          <div className="share-item__text copy-link">
            {this.context.t('Copy link')}
          </div>
        </section>
      </div>
    );
  }
}

ShareCopyLink.propTypes = {
  url: PropTypes.string.isRequired,
  setShared: PropTypes.func.isRequired,
  sendGTMEvents: PropTypes.func.isRequired,
  setTimeout: PropTypes.func.isRequired,
};

ShareCopyLink.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  sendGTMEvents: (payload) => dispatch(sendGTMEvents(payload)),
});

export default connect(null, mapDispatchToProps)(ReactTimeout(ShareCopyLink));
